export const CARRIER_CHANGE_TRACKING = {
  equipmentSearch: {
    source: 'carrier.equipment_search.search',
    id: 12001,
  },
  laneSearch: {
    source: 'carrier.lane_search.search',
    id: 12002,
  },
} as const;
